export type ClipperRankBadge = {
  tier_id: string;
  season_id?: string | null;
  season_name?: string | null;
};

export type ClipperRankFamily = {
  id: string;
  featured_tier_id?: string | null;
  badges: ClipperRankBadge[];
};

export const RANK_FAMILY_ORDER = [
  'season',
  'views',
  'campaign_money',
  'affiliate',
  'campaigns',
  'renders',
] as const;
